import { __awaiter, __decorate, __extends, __generator, __metadata, __param } from "tslib";
import { inject, injectable } from 'tsyringe';
import { getWebStoreApiClient } from '@gn-audio/core/auth/web-store-api';
import { createElement } from '@gn-audio/core/common/templating';
import { getAuthBearerValue, isSiteFeatureEnabled } from '@gn-audio/core/common/utilities';
import { BasketPlugin } from '../../models';
import { SFCCTokenService } from '../../services/sfcc-token.service';
import { emulateClickWhenEnterOrSpacePressed, getBasketTotalCount, saveBasketToStorage } from '../../utilities';
import './basket-authorization.plugin.scss';
import template from './basket-authorization.plugin.html';
var BasketAuthorizationPlugin = /** @class */ (function (_super) {
    __extends(BasketAuthorizationPlugin, _super);
    function BasketAuthorizationPlugin(tokenService, settings) {
        var _this = _super.call(this) || this;
        _this.tokenService = tokenService;
        _this.settings = settings;
        _this.goToCheckoutStorageKey = 'sfcc-go-to-checkout';
        /**
         * Resets component's state if page was restored from bfcache
         * @param event Page transition event
         * @remarks https://web.dev/bfcache/
         */
        _this.resetAfterPageShow = function (event) {
            // Checks whether page was restored from bfcache.
            if (!event.persisted) {
                return;
            }
            // Checks whether element is currently visible
            if (!_this.element.classList.contains("visible" /* CssClass.Visible */)) {
                return;
            }
            // Reset elements' state if page was restored from bfcache.
            _this.hide();
            _this.eventBus.post("hide-loader-ui" /* BasketEvent.HideLoaderUI */);
            _this.eventBus.post("hide-basket-ui" /* BasketEvent.HideBasketUI */);
        };
        _this.handleKeysPressesOnBackButton = function (event) {
            emulateClickWhenEnterOrSpacePressed(event, _this.backButton);
        };
        _this.showAuthorizationOptions = function () {
            _this.element.style.top = "".concat(_this.basketHeaderElement.clientHeight, "px");
            _this.element.classList.add("visible" /* CssClass.Visible */);
        };
        _this.hide = function () {
            _this.element.classList.remove("visible" /* CssClass.Visible */);
        };
        _this.saveBasketState = function (state) {
            _this.state = state;
        };
        _this.submit = function (e) { return __awaiter(_this, void 0, void 0, function () {
            var tokenHiddenInput, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        e.preventDefault();
                        this.storage.removeItem(this.goToCheckoutStorageKey);
                        tokenHiddenInput = this.guestForm.querySelector('input[name="token"]');
                        _a = tokenHiddenInput;
                        _b = getAuthBearerValue;
                        return [4 /*yield*/, this.tokenService.ensure()];
                    case 1:
                        _a.value = _b.apply(void 0, [_c.sent()]);
                        this.eventBus.post("show-loader-ui" /* BasketEvent.ShowLoaderUI */);
                        this.guestForm.submit();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.signInOrSignUp = function () { return __awaiter(_this, void 0, void 0, function () {
            var totalCount, token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.eventBus.post("show-loader-ui" /* BasketEvent.ShowLoaderUI */);
                        totalCount = getBasketTotalCount(this.state);
                        if (!(totalCount > 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, getWebStoreApiClient().onTokenAcquired];
                    case 1:
                        token = _a.sent();
                        saveBasketToStorage(this.storage, token, this.state);
                        // Mark that after registering it should go to checkout
                        this.storage.setItem(this.goToCheckoutStorageKey, 'true');
                        _a.label = 2;
                    case 2:
                        getWebStoreApiClient()
                            .signIn();
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    BasketAuthorizationPlugin.prototype.register = function (_a) {
        var eventBus = _a.eventBus, state = _a.state, storage = _a.storage, translations = _a.translations;
        this.eventBus = eventBus;
        this.eventBus.subscribe("show-authorization-options" /* BasketEvent.ShowAuthorizationOptions */, this.showAuthorizationOptions);
        this.eventBus.subscribe("basket-updated" /* BasketEvent.BasketUpdated */, this.saveBasketState);
        this.state = state;
        this.storage = storage;
        this.basketHeaderElement = document.querySelector(".basket-ui__header" /* BasketUIElementSelector.BasketHeader */);
        this.basketUIElement = document.querySelector(".basket-ui" /* BasketUIElementSelector.BasketUI */);
        this.element = createElement(template, { actionUrl: this.settings.basketCheckoutUrl }, translations);
        this.basketUIElement.appendChild(this.element);
        this.backButton = this.element.querySelector('.basket-authorization__back');
        this.backButton.addEventListener('click', this.hide);
        this.backButton.addEventListener('keydown', this.handleKeysPressesOnBackButton);
        this.guestForm = this.element.querySelector('.basket-authorization__guest-form');
        this.guestForm.addEventListener('submit', this.submit);
        this.signInButton = this.element.querySelector('.basket-authorization__action--sign-in');
        this.signInButton.addEventListener('click', this.signInOrSignUp);
        this.signUpButton = this.element.querySelector('.basket-authorization__action--sign-up');
        if (this.signUpButton) {
            this.signUpButton.addEventListener('click', this.signInOrSignUp);
        }
        var goToCheckount = this.storage.getItem(this.goToCheckoutStorageKey);
        if (goToCheckount === 'true' && !!getWebStoreApiClient().account) {
            this.submit(new Event(this.goToCheckoutStorageKey));
        }
        this.storage.removeItem(this.goToCheckoutStorageKey);
        window.addEventListener('pageshow', this.resetAfterPageShow);
    };
    BasketAuthorizationPlugin.prototype.shouldRegister = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, isSiteFeatureEnabled("TopMenuUipEnabled" /* SiteFeature.TopMenuUipEnabled */)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    BasketAuthorizationPlugin.prototype.unregister = function () {
        var _a, _b, _c, _d, _e, _f;
        (_a = this.signUpButton) === null || _a === void 0 ? void 0 : _a.removeEventListener('click', this.signInOrSignUp);
        (_b = this.signInButton) === null || _b === void 0 ? void 0 : _b.removeEventListener('click', this.signInOrSignUp);
        (_c = this.guestForm) === null || _c === void 0 ? void 0 : _c.removeEventListener('submit', this.submit);
        (_d = this.backButton) === null || _d === void 0 ? void 0 : _d.removeEventListener('click', this.hide);
        (_e = this.backButton) === null || _e === void 0 ? void 0 : _e.removeEventListener('keydown', this.handleKeysPressesOnBackButton);
        this.eventBus.unsubscribe("show-authorization-options" /* BasketEvent.ShowAuthorizationOptions */, this.showAuthorizationOptions);
        (_f = this.element) === null || _f === void 0 ? void 0 : _f.remove();
    };
    BasketAuthorizationPlugin = __decorate([
        injectable(),
        __param(1, inject("basketSettings" /* DiToken.Settings */)),
        __metadata("design:paramtypes", [SFCCTokenService, Object])
    ], BasketAuthorizationPlugin);
    return BasketAuthorizationPlugin;
}(BasketPlugin));
export { BasketAuthorizationPlugin };
